module.exports = __webpack_public_path__ + "fonts/CeraPro-Regular.3e2192d9.woff2";